export default "__VITE_ASSET__CZYE8hg7__"